import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';
const License = ()=>{
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div  className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>用户协议</h2>
            <p><strong>软件许可及用户协议</strong></p>
            <p><strong>欢迎您使用Dreamehome App软件及服务 </strong></p>
            <p>为使用Dreamehome
                App软件及服务，追觅创新科技（苏州）有限公司以及其关联公司（以下简称“追觅”）在此特别提醒用户认真阅读、充分理解本《软件许可及用户协议》（下称“本协议”）及《Dreamehome隐私政策》。<strong>用户应认真阅读、充分理解本协议中各条款，特别涉及免除或者限制责任、争议解决和法律适用的条款。免除或者限制责任的条款将以粗体标识，您需要重点阅读。请您审慎阅读并选择接受或不接受本协议（未成年人应在法定监护人陪同下阅读）。您的下载、安装、使用本软件以及账号获取和登录等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。</strong>
            </p>
            <p><strong>一、总则</strong></p>
            <p>1.1 本协议是您（如下也称“用户”，指的注册、登录、使用、浏览本软件及服务的个人或组织）与追觅及其运营合作单位（如下简称“合作单位”）之间关于用户下载、安装、使用“Dreamehome
                App”软件（下称“本软件”）以及使用追觅相关服务所订立的协议。</p>
            <p>1.2 本软件及服务是追觅提供的安装在包括但不限于移动智能终端设备上的软件和服务，为使用该智能终端的用户提供绑定、操作智能产品等服务等。</p>
            <p><strong>二、软件的获取</strong></p>
            <p>2.1 用户应当按照追觅的官网、官方应用平台以及追觅授权的第三方网站、应用分发平台等追觅官方或追觅授权的渠道下载获取本软件产品。</p>
            <p>2.2
                请您谨防在非指定追觅官方或追觅授权的第三方获取本软件，以免移动终端设备感染能破坏用户数据和获取用户隐私信息的恶意程序。如果用户从未经追觅授权的第三方获取本软件或与本软件名称相同的安装程序，追觅无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。
            </p>
            <p><strong>三、软件的安装与卸载</strong></p>
            <p>3.1 用户必须选择与所安装终端设备相匹配的本软件版本，否则，由于软件与设备型号不相匹配所导致的任何软件问题、设备问题或损害，均由用户自行承担。</p>
            <p>3.2 因经营策略安排或调整等原因，不同地区的用户可使用Dreamehome App服务的内容可能会存在差异，具体以Dreamehome App实际提供的为准。</p>
            <p>3.3 如您不再需要使用本软件或需要安装新版软件，可以自行卸载。</p>
            <p>3.4 软件新版本发布后，追觅不保证旧版本软件的继续可用。</p>
            <p>3.5
                为了改善用户体验、完善服务内容，追觅有权不时地为您提供本软件替换、修改、升级版本，也有权为替换、修改或升级收取费用，但将收费提前征得您的同意。本软件为用户默认开通“升级提示”功能，视用户使用的软件版本差异，追觅供给用户自行选择是否需要开通此功能。软件新版本发布后，追觅不保证旧版本软件的继续可用。
            </p>
            <p><strong>四、软件的更新</strong></p>
            <p>4.1 为了增进用户体验、完善服务内容，追觅可能不断努力开发新的服务，并为您不时提供软件更新。</p>
            <p>4.2 为了改善用户体验或提高服务安全性、保证功能的一致性等目的，追觅有权对本软件进行更新，或者对软件的部分功能效果进行改变。</p>
            <p>4.3 本软件新版本发布后，旧版本的软件可能无法使用。追觅不保证旧版本软件继续可用，也不保证继续对旧版本软件提供相应的客服和维护服务，请您随时核对并下载最新版本。</p>
            <p><strong>五、使用规范</strong></p>
            <p><strong>5.1 用户注册与账号：</strong></p>
            <ul>
                <li>5.1.1 要使用Dreamehome App软件服务，用户必须注册一个用户帐户（以下简称您的“帐户”）并在提示的注册表中提供关于您自己的特定信息。 您同意您所提交的所有信息均真实准确并且您会及时更新此类信息。
                </li>
                <li>5.1.2 创建账户或使用Dreamehome
                    App软件，即表示您确认接受本协议。您也确认您根据您所在的国家的法律已经成年；或者您根据您所在的国家的法律还未成年（“未成年人”），且您表明您已与您的父母或法定监护人共同阅读本协议，且您和您的父母或监护人理解并同意本条款的条款和条件。如果您是父母或监护人，允许未成年人使用本软件及服务，即表示您同意：(i)
                    监督未成年人使用本软件及服务；(ii) 承担与未成年人使用本软件及服务相关的所有风险；(iii)承担因未成年人使用本软件及服务导致的任何法律责任；(iv) 确保您或未成年人提交的所有信息准确、真实；以及 (v)
                    承担未成年人访问和使用本软件及服务导致的任何责任并受本条款约束。</li>
                <li>5.1.3 用户应当按照法律法规和服务要求，按相应页面的提示准确提供并及时更新用户账号的资料，以使之真实、及时、完整和准确。</li>
                <li>5.1.4 帐号的所有权归追觅所有，用户完成申请注册手续后，仅获得帐号的使用权，且该使用权仅属于初始申请注册人。</li>
                <li>5.1.5 用户有责任妥善保管注册帐户信息及帐户密码的安全，用户需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露帐户及密码信息。当在你怀疑他人在使用你的帐号时，你应立即通知追觅。</li>
            </ul>
            <p><strong>5.2 用户禁止的行为：</strong></p>
            <ul>
                <li>5.2.1 删除本软件及其他副本上一切关于版权的信息，以及修改、删除或避开本软件为保护知识产权而设置的技术措施。</li>
                <li>5.2.2 对本软件进行反向工程，如反汇编、反编译或者其他试图获得本软件的源代码。</li>
                <li>5.2.3 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的。</li>
                <li>5.2.4
                    使用本软件进行任何危害网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户；未经允许进入公众网络或者他人操作系统并删除、修改、增加存储信息；未经许可企图探查、扫描、测试本软件的系统或网络的弱点或其它实施破坏网络安全的行为；
                    企图干涉、破坏本软件系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称。</li>
                <li>5.2.5 用户通过非追觅公司开发、授权或认可的第三方兼容软件、系统登录或使用本软件及服务，或制作、发布、传播上述工具。</li>
                <li>5.2.6
                    未经追觅书面同意，用户对软件及其中的信息擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助本软件发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等。
                </li>
                <li>5.2.7 利用本软件发表、传送、传播、储存违反当地法律法规的内容。</li>
                <li>5.2.8 利用本软件发表、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容。</li>
                <li>5.2.9 利用本软件批量发表、传送、传播广告信息及垃圾信息。</li>
                <li>5.2.10 其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议许可使用不一致的方式使用本软件和追觅提供的其他服务。</li>
            </ul>
            <p><strong>5.3</strong><strong> 信息发布规范：</strong></p>
            <ul>
                <li>5.3.1
                    您可使用本软件发表属于您原创或您有权发表的观点看法、数据、文字、信息、用户名、图片、照片、个人信息、音频、视频文件、链接等信息内容。您必须保证，您拥有您所上传信息内容的知识产权或已获得合法授权，您使用本软件及服务的任何行为未侵犯任何第三方之合法权益。
                </li>
                <li>5.3.2 您在使用本软件时需遵守当地法律法规要求。</li>
                <li>5.3.3 您在使用本软件时不得利用本软件从事以下行为，包括但不限于：</li>
            </ul>
            <p>5.3.3.1制作、复制、发布、传播、储存违反当地法律法规的内容。</p>
            <p>5.3.3.2发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容。</p>
            <p>5.3.3.3虚构事实、隐瞒真相以误导、欺骗他人。</p>
            <p>5.3.3.4发表、传送、传播广告信息及垃圾信息。</p>
            <p>5.3.3.5从事其他违反当地法律法规的行为。</p>
            <p>5.3.3.6未经追觅许可，您不得在本软件中进行任何诸如发布广告、销售商品的商业行为。</p>
            <p><strong>5.4 您理解并同意：</strong></p>
            <ul>
                <li>5.4.1 追觅会对用户是否涉嫌违反上述使用规范做出认定，并根据认定结果中止、终止对您的使用许可或采取其他依本约定可采取的限制措施。</li>
                <li>5.4.2 对于用户使用许可软件时发布的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息，追觅会直接删除。</li>
                <li>5.4.3 对于用户违反上述使用规范的行为对第三方造成损害的，您需要以自己的名义独立承担法律责任，并应确保追觅免于因此产生损失或增加费用。</li>
                <li>5.4.4 若用户违反有关法律规定或协议约定，使追觅遭受损失，或受到第三方的索赔，或受到行政管理机关的处罚，用户应当赔偿追觅因此造成的损失和（或）发生的费用，包括合理的律师费、调查取证费用。</li>
            </ul>
            <p><strong>六、软件授权</strong></p>
            <p>6.1 在用户同意遵守本协议及其《Dreamehome隐私政策》的情况下，追觅就本软件给予用户在其所在国境内一项个人的、不可转让、不可转授权以及非独占性的有限许可。</p>
            <p>6.2
                用户可以为非商业目的在单一台移动终端设备上安装、使用、显示、运行本软件。但用户不得为商业运营目的安装、使用、运行本软件，不可以对本软件或者本软件运行过程中释放到任何终端设备内存中的数据及本软件运行过程中客户端与服务器端的交互数据进行复制、更改、修改、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经授权的第三方工具/服务接入本软件和相关系统。如果需要进行商业性的销售、复制和散发，例如软件预装和捆绑，必须获得追觅的书面授权和许可。
            </p>
            <p>6.3 用户不得未经追觅许可，将本软件安装在未经追觅明示许可的其他终端设备上，包括但不限于机顶盒、游戏机、电视机、DVD机等。</p>
            <p>6.4 用户可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息。</p>
            <p>6.5 除本《协议》明示授权外，追觅未授权给用户其他权利，若用户使用其他权利时须另外取得追觅的书面同意。</p>
            <p><strong>七、责任限制及免责声明</strong></p>
            <p><strong>7.1</strong> <strong>责任限制</strong></p>
            <p>
                <strong>在您所在司法辖区适用法律允许的最大范围内，您将自行承担访问和使用本软件及服务可能面临的风险。追觅明确排除因以下情形由您或其他任何人造成的责任、损失或损害，无论是基于合同、侵权（包括过失侵权）或其它任何依据：</strong>
            </p>
            <p><strong>(1) 利润损失、收入损失、收益损失、数据丢失或商誉损失。</strong></p>
            <p><strong>(2) 有关的人身伤害、特别、间接或衍生性损失或损害。无论追觅是否已经知悉或是否应该意识到上述损失出现的可能性，本协议中的限制和排除条款都将适用。</strong></p>
            <p>
                <strong>在您所在司法辖区适用法律允许的最大范围内，无论您何时对本软件及服务的任何方面感到不满意，您唯一的救济措施都是停止访问和使用本软件及服务。在不影响前述限制的情况下，在您所在司法辖区适用法律允许的最大范围内，追觅对您或其他人的任何申索、诉讼、责任、义务、损害、损失及成本的累计责任都不超过您使用本软件及服务支付的价款，无论是基于合同、侵权（包括过失侵权）或其它任何依据。您理解并同意本协议中的免责声明与责任限制公平合理。</strong>
            </p>
            <p><strong>7.2</strong> <strong>免责声明</strong></p>
            <p><strong>在您所在司法辖区适用法律允许的最大范围内，对于您或其他任何人因下列原因无法访问或使用本软件及服务导致的任何责任、损失、损害或赔偿，追觅及其合作方不承担任何责任：</strong></p>
            <p><strong>(1) 追觅对系统或软硬件进行维护或升级导致本软件及服务中止或终止。</strong></p>
            <p><strong>(2) 用户因第三方如通讯线路故障、技术问题、网络、移动终端设备故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失。</strong></p>
            <p><strong>(3)
                本软件同大多数互联网软件一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的终端设备信息和数据的安全，继而影响本软件的正常使用等等。</strong>
            </p>
            <p><strong>(4) 本软件调用第三方系统或第三方软件支持用户的使用或访问，其结果的安全性、准确性、有效性及其他不确定的风险，并由此若引发的任何争议及损害。</strong></p>
            <p><strong>(5) 超越追觅合理控制的其它原因。</strong></p>
            <p><strong>7.3
                部分国家的法律不允许合同中排除或限制某些保证、担保或责任。若这些法律适用于您，则前述排除或限制条款的全部或部分可能不适用于您，您可享有额外的权利。本协议中的任何内容均不影响您作为消费者应该享有的法定权利，您也无法通过同意本合同变更或放弃这些权利。</strong>
            </p>
            <p><strong>八、第三方内容/服务说明</strong></p>
            <p>8.1
                追觅会不时与第三方网站、社交媒体平台、移动应用以及其他商品或服务（“第三方”）链接或合作。您能够通过平台与该第三方互动，但这不代表追觅认可、监控或控制此类第三方或其行为，这些第三方及其行为受单独的使用条款和隐私政策的约束。您应仔细阅读任何第三方网站及其使用条款和隐私政策。追觅不对第三方的内容、政策或活动负责，且您自行承担使用第三方内容和服务的风险。
            </p>
            <p>8.2 用户与第三方内容或服务提供方之间发生的任何争议、纠纷应由用户与第三方服务提供方自行协商解决，追觅不承担任何责任。</p>
            <p><strong>九、知识产权声明</strong></p>
            <p>9.1
                除另有特别声明外，我们在本协议项下提供的产品和服务中的内容（包括但不限于页面、文字、图片、音频、视频、图表等）、提供产品和服务时所依托应用程序、以及在产品和服务中所使用的商标及其他商业标识，其著作权、专利权、商标权或其他相关知识产权和合法权益均归我们所有。
            </p>
            <p>9.2 上述及其他任何我们的产品和服务中包含的内容的知识产权均受到法律保护，未经我们或相关权利人事先书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</p>
            <p><strong>十、协议的修改和终止</strong></p>
            <p>10.1 一些司法管辖区不允许单方更新或变更消费条款，因此本段可能对您不适用。在您所在司法辖区适用法律允许的最大范围内：</p>
            <p>(1) 我们可能会不时更新这些条款。如果发生重大变更，我们将在Dreamehome App或我们的官网上发布通知或向您发送通知。请阅读全部变更。如果您不同意任何变更，请停止使用Dreamehome
                App。如果在我们通知您变更后您继续使用我们的Dreamehome App，除非适用法律禁止，您将被视为已接受了更新后的条款。</p>
            <p>(2)
                追觅和合作公司有权按需要修改或变更所提供的收费服务、收费标准、收费方式、服务费及服务条款。追觅在提供服务时，可能现在或日后对部分服务的用户开始收取一定的费用如用户拒绝支付该等费用，则不能在收费开始后继续使用相关的服务。追觅和合作公司将尽最大努力通过电邮或其他方式通知用户有关的修改或变更。
            </p>
            <p>(3) 追觅保留在任何时候无需通知而修改、保留或关闭Dreamehome App及其服务的权力。用户已同意追觅无需因修改、保留或关闭Dreamehome App及其服务的行为对用户或第三方承担责任。</p>
            <p>(4) 依据适用法律，追觅可以不承担任何责任地在任何时间因任何原因终止或暂停用户的账户、删除您的档案或任何用户内容，或者限制您使用全部或部分本软件及服务。</p>
            <p>(5) 本条款在您的账户终止或您停止使用本软件及服务后仍然有效。</p>
            <p><strong>十一、适用法律及争议解决</strong></p>
            <p>11.1 如果您在美国居住，则本协议将按照加利福尼亚州和美国法律解释，而不考虑法律冲突条文。本协议而产生或与使用本软件及服务有关的任何争议应提交至位于加利福尼亚州旧金山的州或联邦法院，除非双方一致同意在其他地点进行诉讼。
                您和我们均同意加利福尼亚州旧金山市作为审理地点并接受其属人管辖。</p>
            <p>11.2 如果您在欧洲经济体或英国居住，您同本协议在所有方面均受荷兰法律管辖，但法律冲突规则除外，也不适用1980年《联合国国际货物销售合同公约》。</p>
            <p>除禁止和限制消费者的任何法定权利的情形外，您因本协议产生的争议的法律程序应得到解决并排他地受荷兰阿姆斯特丹的适格法院管辖，但法律冲突规则除外</p>
            <p>如果您有任何投诉意见，请通过联系我们与我们联系。如果您觉得您的投诉没有得到充分解决，您可以，但没有义务，通过<a className="page"
                href="http://ec.europa.eu/odr">http://ec.europa.eu/odr</a>访问在线争议解决（ODR）平台。此外，您有权通过以下方式联系调解员来启动调解程序：欧洲调解员协会（197，Boulevard
                Saint-Germain，75007 巴黎，联系电话：09 53 01 02 69），<a className="page"
                    href="http://www.mediationconso-ame.com/">http://www.mediationconso-ame.com/</a>。调解员将试图独立和公正地达成和解。在调解的情况下，各方可以自由接受或拒绝调解员提出的解决方案。”。
            </p>
            <p>11.3
                如果您在11.1和11.2款以外的国家及地区居住，则本协议受中华人民共和国法律管辖。在这种情况下，因本协议而产生或与使用本软件及服务有关的任何争议应提交上海国际经济贸易仲裁委员会（「贸仲委」）进行仲裁，仲裁应根据申请仲裁时有效的贸仲委仲裁规则进行。仲裁裁决是最终裁决，对双方均有约束力。仲裁庭应由三
                (3) 名仲裁员组成。仲裁地点应为上海。仲裁语言应为中文。</p>
            <p><strong>十二、其他</strong></p>
            <p>12.1 隐私政策</p>
            <p>追觅非常重视您的个人隐私信息，请认真查阅我们的《Dreamehome隐私政策》，《Dreamehome隐私政策》为与本协议效力等同且不可分割的一部分。在任何时候，您的信息均依照《Dreamehome隐私政策》处理</p>
            <p>12.2 本协议生效时间为2021年8月28日。</p>
            <p>12.3 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
            <div className='height'></div>
        </div>
    )
}

export default License